import { OPERATION_MODE } from '@laramie/ui';
import {TIPS} from "../../../consts/tips";

import { FormError, FormLabel, InputCuenta, Modal } from "../../../components/common"
import { useFormErrors } from "../../../components/hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const CuentasPruebaEditModal = ({ item, setItem, mode, onAccept, onCancel }) => {

    const { errorOf, validate } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}

        if (item.idCuenta < 1) errors.idCuenta = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors
    }

    const handleAccept = () => {
        if (!validate()) return

        onAccept()
    }

    return (
        <Modal
            onEscape={onCancel}
            show
            header={<h2 className="modal-title">Definición de cuenta de prueba</h2>}
            tipName={TIPS.NAME.MODALS.CUENTA_PRUEBA_DEFINICION_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12">
                        <FormLabel htmlFor="idCuenta" required>Cuenta</FormLabel>
                        <InputCuenta
                          name="idCuenta"
                          placeholder=""
                          className={`form-control ${errorOf('idCuenta') ? 'is-invalid' : ''}`}
                          value={item.idCuenta}
                          onChange={({ target }) => setItem({ ...item, idCuenta: target.value })}
                          idTipoTributo={item.idTipoTributo}
                          disabled={mode !== OPERATION_MODE.NEW}
                        />
                        <FormError message={errorOf('idCuenta')} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="comentario" className="form-label">Comentario</label>
                        <textarea
                            name="comentario"
                            placeholder=""
                            className="form-control"
                            value={item.comentario}
                            onChange={({ target }) => setItem({ ...item, comentario: target.value })}
                            disabled={mode === OPERATION_MODE.VIEW}
                            rows="4"
                        />
                        <FormError />
                    </div>
                </div>
            )}
            footer={<>
                {mode !== OPERATION_MODE.VIEW && ( <>
                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onCancel}>Cancelar</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={handleAccept}>Aceptar</button>
                </>)}
                {mode == OPERATION_MODE.VIEW && ( 
                <div className="width-100p f-align">
                    <button className="btn back-button" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>)}
            </>}
        />
    )
}

export default CuentasPruebaEditModal
